import hatStyles, { type HatStyles } from "../1-style/hatStyles";

type Materials = {
	[key: string]: {
		[key: string]: string;
	};
};

type MaterialDescriptions = {
	[key: string]: string;
};

type MaterialNames = {
	[key: string]: string;
};

const materials = Object.entries(hatStyles).reduce((acc, [hatStyle, hatStyleData]) => {
	const materials = Object.entries(hatStyleData.materials).reduce((acc, [_, materialData]) => {
		const { name, price, description } = materialData;
		const key = `${name} - $${price}`;
		acc[key] = description;
		return acc;
	}, {} as MaterialDescriptions);
	acc[hatStyle] = materials;
	return acc;
}, {} as Materials);

const materialNameStyles = Object.entries(hatStyles).reduce(
	(acc, [hatStyle, _]) => {
		const materials = Object.entries(hatStyles[hatStyle].materials).reduce(
			(acc, [_, materialData]) => {
				const { name, price, defaultSwatch } = materialData;
				const key = `${name} - $${price}`;
				acc[key] = defaultSwatch;
				return acc;
			},
			{} as MaterialNames,
		);
		acc[hatStyle] = materials;
		return acc;
	},
	{} as {
		[key: string]: MaterialNames;
	},
);
const materialNames = Object.values(materialNameStyles).reduce((acc, material) => {
	for (const [key, value] of Object.entries(material)) {
		acc[key] = value;
	}
	return acc;
}, {});

const materialsData: Materials = Object.entries(hatStyles).reduce((acc, [_, hatStyleData]) => {
	return {
		...acc,
		...hatStyleData.materials,
	};
}, {});

const materialDescriptions = Object.values(materials).reduce((acc, material) => {
	for (const [key, value] of Object.entries(material)) {
		acc[key] = value;
	}
	return acc;
}, {} as MaterialDescriptions);

const findMaterialWithLabel = (hatStyles: HatStyles, targetLabel: string) => {
	return Object.entries(hatStyles)
		.flatMap(([_, hatType]) => Object.values(hatType.materials))
		.filter((material) => {
			// console.log(
			//   "material labels ",
			//   material.label.toLowerCase(),
			//   targetLabel.toLowerCase(),
			//   material.label.toLowerCase() === targetLabel.toLowerCase()
			// );
			return material.label.toLowerCase() === targetLabel.toLowerCase();
		});
};

const findMaterialWithConstructedLabel = (hatStyles: HatStyles, targetLabel: string) => {
	return Object.entries(hatStyles)
		.flatMap(([_, hatType]) => Object.values(hatType.materials))
		.filter((material) => `${material.name} - $${material.price}` === targetLabel);
};

export {
	materials,
	materialDescriptions,
	materialNames,
	materialNameStyles,
	materialsData,
	findMaterialWithLabel,
	findMaterialWithConstructedLabel,
};
